<mat-dialog-content class="error-dialog-container">
  <div class="icon-container" [ngClass]="data.iconType">
    <mat-icon class="alert-icon">
      {{ { 'error': 'close', 'success': 'check', 'warning': 'warning', 'info': 'info' }[data.iconType] }}
    </mat-icon>
  </div>

  <div class="text-container">
    <h2 mat-dialog-title class="dialog-title">{{ data.title | translate }}</h2>
    <div class="dialog-message">
      {{ data.message | translate }}
    </div>
  </div>

  <div mat-dialog-actions class="dialog-actions-group">
    <button *ngIf="data.showSecondaryButton"
      mat-button
      class="secondary-button"
      (click)="onDismiss()">
      {{ data.secondaryButtonText | translate }}
    </button>

    <button mat-raised-button
      class="ok-button"
      [ngClass]="[data.iconType, !data.showSecondaryButton ? 'solo-button' : '']"
      (click)="onConfirm()">
      {{ data.mainButtonText | translate }}
    </button>
  </div>
</mat-dialog-content>
